export const COMPONENT_NAME = "admin-kyc-kyb-registration-information";
